#import "../../../graphql/fragments/email-attachment.graphql"
#import "./nut-email-address.graphql"

fragment Email on Email {
    id
    to {
        ...NutEmailAddress
    }
    cc {
        ...NutEmailAddress
    }
    from {
        ...NutEmailAddress
    }
    createdTime
    sentTime
    deletedTime
    attachments {
        ...EmailAttachment
    }
    subject
    bodyText
    bodyHtml
    htmlUrl
    isShared
    isShareable
    isReplyable
    emailSequence {
        id
        messageCount
        emailSequenceTemplate {
            id
            name
        }
    }
    queuedEmail {
        messageNumber
        htmlUrl
    }
    trackedViewsCount
    isAutomatedReply
    isEmailAutomation
}
